import { apiRequest } from './api';

// Gym members service
export const gymMembersService = {
  // Get all gym members
  getAllMembers: async () => {
    return await apiRequest('/get_usergym_info', {
      method: 'GET',
      includeAuth: true,
    });
  },

  // Get a paginated gym member list for the admin table
  getMembersPage: async ({ page = 1, pageSize = 200, search = '', feesStatus = 'all', signal } = {}) => {
    const params = new URLSearchParams({
      paginated: 'true',
      page: String(page),
      pageSize: String(pageSize),
    });

    if (search) {
      params.set('search', search);
    }

    if (feesStatus && feesStatus !== 'all') {
      params.set('feesStatus', feesStatus);
    }

    return await apiRequest(`/get_usergym_info?${params.toString()}`, {
      method: 'GET',
      includeAuth: true,
      signal,
    });
  },

  // Create new gym member
  createMember: async (memberData) => {
    return await apiRequest('/create_user', {
      method: 'POST',
      body: memberData,
      includeAuth: true,
    });
  },

  // Update existing gym member
  updateMember: async (memberData) => {
    return await apiRequest('/update_user', {
      method: 'POST',
      body: memberData,
      includeAuth: true,
    });
  },

  // Delete gym member
  deleteMember: async (memberId) => {
    return await apiRequest('/delete_user', {
      method: 'POST',
      body: { _id: memberId },
      includeAuth: true,
    });
  },

  // Update member measurements
  updateMeasurements: async (measurementData) => {
    return await apiRequest('/update_measurements', {
      method: 'POST',
      body: measurementData,
      includeAuth: true,
    });
  },

  // Get recently deleted members
  getRecentlyDeleted: async () => {
    return await apiRequest('/get_recently_deleted', {
      method: 'GET',
      includeAuth: true,
    });
  },

  // Restore deleted member
  restoreMember: async (memberId) => {
    return await apiRequest('/restore_user', {
      method: 'POST',
      body: { _id: memberId },
      includeAuth: true,
    });
  },

  // Permanently delete member
  permanentlyDeleteMember: async (memberId) => {
    return await apiRequest('/permanently_delete_user', {
      method: 'POST',
      body: { _id: memberId },
      includeAuth: true,
    });
  }
};
